import { useHead } from '@vueuse/head'
import { computed } from 'vue'

import { useSponsorshipStore } from '@/stores/sponsorship'

export const fetchSponsorshipStore = async (slug: string) => {
  const sponsorshipStore = useSponsorshipStore()

  await sponsorshipStore.fetchSponsorshipData(slug, 'sponsorship_template_one')
}

export const fetchSponsorshipOverviewStore = async () => {
  const sponsorshipStore = useSponsorshipStore()
  await sponsorshipStore.fetchSponsorshipOverview()
}

export const useOverviewData = () => {
  const sponsorshipStore = useSponsorshipStore()
  return computed(() => sponsorshipStore.getSponsorshipOverviewData)
}

export const useSponsorshipData = () => {
  const sponsorshipStore = useSponsorshipStore()
  return computed(() => sponsorshipStore.getSponsorshipData)
}

export const useSponsorshipLoading = () => {}

export const useSponsorshipSeo = () => {
  useHead({
    title: useSponsorshipSeoTitle(),
    meta: [
      {
        name: 'description',
        content: useSponsorshipSeoDescription()
      },
      {
        property: 'og:title',
        content: useSponsorshipSeoTitle()
      },
      {
        property: 'og:description',
        content: useSponsorshipSeoDescription()
      }
    ]
  })
}

export const useSponsorshipOverviewSeo = () => {
  useHead({
    title: useSponsorshipOverviewSeoTitle(),
    meta: [
      {
        name: 'description',
        content: useSponsorshipSeoOverviewDescription()
      },
      {
        property: 'og:title',
        content: useSponsorshipOverviewSeoTitle()
      },
      {
        property: 'og:description',
        content: useSponsorshipSeoOverviewDescription()
      }
    ]
  })
}

export const useSponsorshipOverviewSeoTitle = () => {
  const sponsorshipStore = useSponsorshipStore()
  return computed(() => {
    if (sponsorshipStore.getSponsorshipOverviewData?.seo_page?.title) {
      return sponsorshipStore.getSponsorshipOverviewData.seo_page.title
    }
    return 'Default Title'
  })
}

export const useSponsorshipSeoOverviewDescription = () => {
  const sponsorshipStore = useSponsorshipStore()
  return computed(() => {
    if (sponsorshipStore.getSponsorshipOverviewData?.seo_page?.description) {
      return sponsorshipStore.getSponsorshipOverviewData?.seo_page.description
    }
    return 'Default Description'
  })
}

export const useSponsorshipSeoTitle = () => {
  const sponsorshipStore = useSponsorshipStore()
  return computed(() => {
    if (sponsorshipStore.getSponsorshipData?.seo_page?.title) {
      return sponsorshipStore.getSponsorshipData?.seo_page?.title
    }
    return 'Default Title'
  })
}

export const useSponsorshipSeoDescription = () => {
  const sponsorshipStore = useSponsorshipStore()
  return computed(() => {
    if (sponsorshipStore.getSponsorshipData?.seo_page?.description) {
      return sponsorshipStore.getSponsorshipData?.seo_page?.description
    }
    return 'Default Description'
  })
}
